import * as React from 'react';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { UIHelper } from '../../utils/UIHelper';

export interface WrapForScrollProps extends React.Props<HTMLDivElement> {
    className: string;
}

export const WrapForScroll: React.StatelessComponent<WrapForScrollProps> = (props: WrapForScrollProps) => {
    return (
        <div className={props.className}>
            {
                (AppConfigurationStore.getState().inApp && UIHelper.customScrollbarEnabled()) ?
                    props.children :
                    <div className="scrollbar-wcf">{props.children}</div>
            }
        </div>);
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/WrapForScroll.tsx